exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-header[data-v-7d4338ea]{font-size:16px}.box-card-item[data-v-7d4338ea]{margin-bottom:12px}.box-item-area[data-v-7d4338ea]{border:1px solid #707070;margin-top:20px;padding:20px;border-radius:5px}.flex-start[data-v-7d4338ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.notes[data-v-7d4338ea]{font-size:12px}", ""]);

// exports
